import React from 'react'

import { twMerge } from 'tailwind-merge'

import {
  RICH_TEXT_AREA_NO_BLUR_CLASSNAME,
  RichTextArea,
} from '@/components/common/TextArea/RichTextArea'
import ErrorMessage from '@/components/form/ErrorMessage'

export const DEFAULT_TEXT_STYLES = twMerge(
  'tiptap-y-margin-0 prose-p:my-[10px] prose-ul:my-[10px] prose-ol:my-[10px] leading-[22px] text-primary-700 dark:text-primary-300',
  'text-sm prose prose-light dark:prose-light america:prose-blue prose-sm dark:!prose-invert text-primary-900 dark:!prose-primary-100',
  'prose-headings:!text-primary-800 dark:prose-headings:!text-primary-200',
)

interface RichTextDescriptionFieldProps {
  value: string | undefined
  onChange: (value: string) => void
  error?: string
  placeholder?: string
  className?: string
}

export const RichTextDescriptionField: React.FC<
  RichTextDescriptionFieldProps
> = ({
  value,
  onChange,
  error,
  placeholder = 'Add a description...',
  className,
}) => {
  return (
    <>
      <RichTextArea
        valueType="markdown"
        value={value ?? ''}
        onChange={onChange}
        placeholder={placeholder}
        placeholderClassName="before:text-sm before:text-primary-500 dark:before:text-primary-400"
        className={twMerge(
          'min-h-[132px] dark:bg-default-dark dark:border-primary-800',
          'transition-[border-color,box-shadow,opacity]',
          'focus-within:border-accent-400 focus-within:ring-accent-400 dark:focus-within:border-accent-400/50 dark:focus-within:ring-accent-400/50 focus-within:ring-[2px]',
          'selection:bg-primary-300 selection:text-primary-700 dark:selection:bg-primary-600 dark:selection:text-primary-100',
          RICH_TEXT_AREA_NO_BLUR_CLASSNAME,
          className,
        )}
        extensionsConfig={{
          indent: false,
        }}
      >
        <RichTextArea.Header
          className={twMerge(
            RICH_TEXT_AREA_NO_BLUR_CLASSNAME,
            'border-b border-primary-200 dark:border-primary-800',
            'dark:bg-primary-900 dark:border-primary-800',
          )}
        />
        <RichTextArea.Content
          className={twMerge(
            'max-h-[300px] overflow-y-auto',
            DEFAULT_TEXT_STYLES,
          )}
        />
        <RichTextArea.LinkMenu />
      </RichTextArea>
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </>
  )
}
